// extracted by mini-css-extract-plugin
module.exports = {"fbIcon":"styles_fbIcon__2v3C5","fbIconWrapper":"styles_fbIconWrapper__B0WoH","fbButton":"styles_fbButton__35m4r","fbText":"styles_fbText__TyV8h"};